import { useState, useEffect } from 'react'

export const useGroupSearchable = () => {
  const [searchableText, setSearchableText] = useState<string>('')
  const [isShow, setIsShow] = useState(false)
  const [groupDialogDetailTitle, setGroupDialogDetailTitle] = useState('')

  useEffect(() => {
    if (searchableText) {
      setIsShow(true)
      setGroupDialogDetailTitle(searchableText)
    }
  }, [searchableText])

  const onCancel = () => {
    setSearchableText('')
    setGroupDialogDetailTitle('')
    setIsShow(false)
  }

  return {
    searchableText,
    isShow,
    groupDialogDetailTitle,
    setSearchableText,
    onCancel,
    setGroupDialogDetailTitle,
  }
}
